import React, { Component, useEffect } from 'react';
import { Routes, Route, Outlet, Link } from "react-router-dom";
import Sidebar from '../../Components/Sidebar';
import Topbar from '../../Components/Topbar';
import Footer from '../../Components/Footer';
import {Helmet} from "react-helmet";

const { $ } = window;
const LayoutScreen = () => {
    $("#wrapper").css("display","flex");
    return (
        <>
            <Helmet>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
            </Helmet>
            <Sidebar />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <Topbar />
                    <div className="container-fluid">
                        <Outlet />
                    </div>

                </div>

                <Footer />

            </div>
        </>
    );
}

export default LayoutScreen;